// extracted by mini-css-extract-plugin
module.exports = {"loader":"Hypnosis_loader__1t0qW","outer":"Hypnosis_outer__3sEnl","middle":"Hypnosis_middle__1wdcv","inner":"Hypnosis_inner__2bwf3","spin":"Hypnosis_spin__2WMp9"};